/**
 * user-frontend/src/index.js
 *
 * FIX BUG-002: ReactDOM.createRoot chamado com 2 argumentos
 *   root.render(<App/>, document.getElementById('root'))
 *   → 2º argumento é ignorado silenciosamente em React 18
 *   → mas é erro de API que confunde outros devs
 */

import React from 'react';
import ReactDOM from 'react-dom/client';
import './styles/theme.css'; // Design system global (variáveis + classes partilhadas)
import './styles/dozy-home.css'; // Nova direcção visual do dashboard do cliente
import App from './App.js';
import { AuthProvider } from './context/AuthContext.js';
import ToastHost from './components/ToastHost.js';

// Aplica o tema antes do render (evita flash). Padrão: CLARO.
// Só fica escuro se o utilizador o tiver escolhido explicitamente.
try {
  const stored = localStorage.getItem('dozy-theme');
  if (stored !== 'dark') {
    document.documentElement.setAttribute('data-theme', 'light');
  }
} catch {
  document.documentElement.setAttribute('data-theme', 'light');
}

const root = ReactDOM.createRoot(document.getElementById('root'));

// FIX: apenas um argumento — AuthProvider wraps App aqui, não no app.js
root.render(
  <React.StrictMode>
    <AuthProvider>
      <App />
      <ToastHost />
    </AuthProvider>
  </React.StrictMode>
);

// Service worker e o aviso «Nova versão disponível». O registo, o skipWaiting
// e o que não se guarda estão em public/service-worker.js. Aqui só se pede
// à pessoa para recarregar quando um worker novo toma o controlo — um reload
// normal, sem limpar a sessão.
import { iniciarActualizacao } from './pwa/actualizacao.js';

iniciarActualizacao();

// Rede de segurança: se um chunk lazy falhar por a shell estar velha (após um
// deploy), recarrega uma vez para obter o index.html fresco e os chunks certos.
const reloadOnChunkError = (msg) => {
  if (/ChunkLoadError|Loading chunk .* failed/i.test(String(msg || ''))) {
    if (!sessionStorage.getItem('dozy_chunk_reloaded')) {
      sessionStorage.setItem('dozy_chunk_reloaded', '1');
      window.location.reload();
    }
  }
};
window.addEventListener('error', (e) => reloadOnChunkError(e?.message || e?.error?.name));
window.addEventListener('unhandledrejection', (e) => reloadOnChunkError(e?.reason?.message || e?.reason?.name));
